import PanelNotifications from "../../components/PanelNotifications";

export default function ParentNotifications() {
  return (
    <PanelNotifications
      apiPrefix="parent"
      subtitle="Payment receipts when a linked student pays, plus other billing updates."
    />
  );
}
